import { Avatar } from 'shared';

import { RequireEmojiOrPicture } from 'features/challenge/config/types';

type TChallengeInfoImageProps = {
  title: string;
} & RequireEmojiOrPicture;

export const ChallengeInfoImage = ({
  emoji,
  pictureFileUrl,
  pictureUrl,
  title,
}: TChallengeInfoImageProps) => {
  const noImageUrl = !(pictureFileUrl || pictureUrl);

  if (noImageUrl && !emoji) {
    return null;
  }

  return (
    <Avatar
      src={(pictureFileUrl || pictureUrl)!}
      alt={title}
      size="md"
      fallback={emoji}
      shape="rounded"
    />
  );
};
